import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
// import AnalyticsService from '@/services/AnalyticsService'
import * as PATHS from './paths'

// ROUTES
import Loading from '@/components/loading/Loading'
import Home from '@/components/vca/Home'
import Welcome from '@/components/vca/welcome/Welcome'
import Destinations from '@/components/vca/destinations/Destinations2'
import Scenes from '@/components/vca/scenes/Scenes2'
import Ending from '@/components/vca/ending/Ending'


// BASE
//import vueConfig from 'src/../vue.config.js'
var vueConfig = require('src/../vue.config.js')

// INIT
Vue.use(Router)
const router = new Router({
  base: vueConfig.baseUrl,
  // ROUTER MODES
  // 'hash': eg /#/mypage
  // 'history': eg /mypage (requires htaccess or equivalent for deploy)
  // 'abstract': internal routing, no url change
  mode: 'hash',
  routes: [
    // Loading
    {
      path: `/`,
      name: PATHS.LOADING,
      component: Loading,
    },
    // {
    //   path: `/welcome`,
    //   name: PATHS.WELCOME,
    //   component: Welcome,
    // },
    {
      path: `/home`,
      name: 'home',
      component: Home,
      children: [
        {
          path: `/welcome`,
          name: PATHS.WELCOME,
          component: Welcome,
        },
        {
          path: `/destinations`,
          name: PATHS.DESTINATIONS,
          component: Destinations,
        },
        {
          path: `/${PATHS.SCENES}/:id`,
          name: PATHS.SCENES,
          component: Scenes,
          props: true
        },
        {
          path: '/ending',
          name: PATHS.ENDING,
          component: Ending
        }
      ]
    },
    // {
    //   path: `/${PATHS.SCENES}/:id`,
    //   name: PATHS.SCENES,
    //   component: Scenes,
    //   props: true
    // },
    // {
    //   path: '/ending',
    //   name: PATHS.ENDING,
    //   component: Ending
    // }

  ],
})
export default router

// ROUTE GUARD
router.beforeEach((to, from, next) => {
  //console.log(from)
  if (to.name !== PATHS.LOADING && !store.state.app.loading.completed) {
    // if (typeof to.name === 'string' && to.name !== PATHS.START) {
    //   store.commit('app/setRouteAfterLoad', to.path)
    // }
    return next({ name: PATHS.LOADING })
  }
  next()
})

// START IF ABSTRACT MODE
if (router.mode === 'abstract') {
  router.replace('/')
}

// AFTER HOOK
router.afterEach(() => {
  // store.commit('app/setRoute', {
  //   parent: to.matched[0].name,
  //   child: (to.matched[1] || { name: null }).name,
  // })
  // AnalyticsService.sendPageview(to.fullPath)
})

window.router = router
